import { useLocation } from "react-router";

export default function useOnlineAckToken() {
    const query = new URLSearchParams(useLocation().search);
    const onlineAckToken = query.get("OnlineAckToken") ?? undefined;  
    return onlineAckToken;
}